import { i18n } from 'utils';

export const FLUENT_INVALID = {
  code: 'FLUENT_INVALID',
  message: i18n._('Your FTL is not valid.'),
  description: i18n._('Your FTL file could not be parsed.'),
};
